import * as React from 'react';

import { ParticipantHelp } from 'src/containers/Helps';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
// import Config from '../../site.config.json';
import i18n from '../../resources/i18n';
const title = i18n.t('Participant_0001');

/**
 * 受講者ヘルプ画面
 * @param _ propsなし
 */
const Participant: React.FC<{}> = _ => (
	<React.Fragment>
		<MainMenu />
		<Navbar title={title} />
		<ParticipantHelp />
	</React.Fragment>
);

/**
 * 受講者ヘルプ画面
 * @param _ propsなし
 */
export default Participant;



// WEBPACK FOOTER //
// ./src/pages/help/Participant.tsx